import type { FC } from 'react';

import type { CalendarDropdownOption } from '../calendar/default_options';
import InputDate, { type InputDateProps } from '../input_date/input_date';

type Props = Omit<InputDateProps, 'optionsDropdown' | 'optionsPresets'>;

const initialOptionsDropdown: CalendarDropdownOption[] = [];
const initialOptionsPresets: CalendarDropdownOption[] = [];

const InputDateSimple: FC<Props> = ({ isRangeMode = false, ...props }) => (
  <InputDate
    {...props}
    isRangeMode={isRangeMode}
    optionsDropdown={initialOptionsDropdown}
    optionsPresets={initialOptionsPresets}
  />
);

export default InputDateSimple;
